import { resolveAppBuildLabel } from 'pi-kiosk-shared';

export const APP_BUILD_LABEL: string = resolveAppBuildLabel({
  appVersion: import.meta.env.VITE_APP_VERSION,
  buildId: import.meta.env.VITE_BUILD_ID,
  fallback: 'dev',
});
